import { compile } from './compiler';
import { analyzer, FieldTypeCategory, flattenAst, parser } from '@thinkalpha/language-services';
import type { FunctionDef } from '@thinkalpha/language-services';

export function smartFilterToTableFilter(text: string, functions: FunctionDef[] = []): string | undefined {
    if (!text) {
        return undefined;
    } else if (text.startsWith('=')) {
        // construct a "complex" filter: verbatim text without the =
        const parsed = parser(text.substring(1), {});
        if (!parsed.root) return undefined;
        const analyzedRoot = analyzer(parsed.root, { functionDefs: functions });
        const valid = parsed.valid && flattenAst(analyzedRoot).every((x) => x.valid);
        if (!valid) return undefined;
        if (analyzedRoot.dataType !== FieldTypeCategory.Boolean) return undefined;

        const compiled = compile(analyzedRoot, {}).result;

        return compiled;
    } else {
        // construct a "simple" filter: make a really complex filter to search the specified text
        const pieces = functions
            .filter((x) => x.overloads.some((y) => !y.params.length && y.returnType === FieldTypeCategory.String))
            .map((x) => `(\`${x.symbol}\` like '%.*${text}.*')`);
        return pieces.join(' or ');
    }
}
